import { render, staticRenderFns } from "./ExportPdfPhysical.vue?vue&type=template&id=1954db69&"
import script from "./ExportPdfPhysical.vue?vue&type=script&lang=js&"
export * from "./ExportPdfPhysical.vue?vue&type=script&lang=js&"
import style0 from "./ExportPdfPhysical.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports